import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { UiState } from './types'

export const state: UiState = {
    colorMode: 'light',
    menuState: 'opened',
}

const namespaced = true

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}
